import { type FunctionComponent } from 'react';
import { type ImageFieldsFragment } from '../../../__generated__/graphql-client-types';
import { DEFAULT_SHOWROOM_HERO_IMAGES } from '../../../constants/showroom/images';
import { CloudinaryImage } from '../../images/cloudinary-image/cloudinary-image.component';
import { largeHero, smallHero } from './showroom-hero-images.css';

export type ShowroomHeroImagesProps = {
	images?: ImageFieldsFragment[];
};

export const ShowroomHeroImages: FunctionComponent<ShowroomHeroImagesProps> = ({ images }) => {
	const filteredImages = images?.filter((item) => item.id);
	const heroImages = filteredImages && filteredImages.length > 1 ? filteredImages : DEFAULT_SHOWROOM_HERO_IMAGES;
	return (
		<div className="w-90 w-80-m w-100-l relative">
			<CloudinaryImage
				publicID={heroImages[0].id}
				options={{ crop: 'fill', type: heroImages[0].imageType }}
				placeholderOptions={{ crop: 'fill', type: heroImages[0].imageType }}
				description={heroImages[0].description}
				useDimensions={false}
				className={`${largeHero} w-100`}
			/>
			<CloudinaryImage
				publicID={heroImages[1].id}
				description={heroImages[1].description}
				options={{ crop: 'fill', type: heroImages[1].imageType }}
				placeholderOptions={{ crop: 'fill', type: heroImages[1].imageType }}
				className={`${smallHero} w-50 absolute`}
				useDimensions={false}
			/>
		</div>
	);
};
